var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"background-color":"#1d2024"}},[_c('color-picker',{attrs:{"color":_vm.color},on:{"changeColor":_vm.changeColor}}),_c('v-btn',{attrs:{"small":""},on:{"click":_vm.closeColor}},[_vm._v("OK")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }